import { Component, OnInit } from '@angular/core';
import { AssessmentComment } from '../../../../../models/assessment-comment';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'lib-assessment-detail-additional-comments-modal',
  templateUrl: './assessment-detail-additional-comments-modal.component.html',
  styleUrls: ['./assessment-detail-additional-comments-modal.component.scss']
})
export class AssessmentDetailAdditionalCommentsModalComponent implements OnInit {
  public additionalComments: Array<AssessmentComment> = [];
  public canEdit: boolean = false;

  constructor(public dynamicDialogRef: DynamicDialogRef,
              public dynamicDialogConfig: DynamicDialogConfig) {
    this.additionalComments = this.dynamicDialogConfig?.data?.additionalComments;
    this.canEdit = this.dynamicDialogConfig?.data?.canEdit === true;
  }

  ngOnInit(): void {
  }

  cancel() {
    this.dynamicDialogRef.close(false);
  }

  save() {
    this.dynamicDialogRef.close(this.additionalComments);
  }
}
